/* istanbul ignore file */
/* eslint-disable react/require-default-props */
import React from 'react';
import { Card } from 'react-bootstrap';
import PropTypes from 'prop-types';
import ReadingDisplay from '../common/ReadingDisplay';
import CardHeader from '../common/CardHeader';
import CardStatusBar from '../common/CardStatusBar';

const SingleReadingCard = ({
  sensorName,
  typeName,
  macAddress = '',
  lastUpdated,
  reading1 = {
    value: 0, units: '', title: 'Unknown', isTriggered: null, channelKey: '',
  },
  isHub,
  rssi = 0,
  isWireless,
  onSettingsClick,
  batteryLevel = 0,
  generalAlerts = [],
  isPluggedIn = false,
  isMuted = false,
}) => (
  <div style={isMuted ? { opacity: 0.5 } : {}}>
    <Card style={{
      width: '16rem', height: '16rem', borderRadius: '10px', color: '#d3d3d3', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    }}
    >
      <CardHeader
        sensorName={sensorName}
        macAddress={macAddress}
        typeName={typeName}
        onSettingsClick={onSettingsClick}
        lastUpdated={lastUpdated}
        isMuted={isMuted}
      />
      <CardStatusBar
        rssi={rssi}
        isWireless={isWireless}
        isHub={isHub}
        batteryLevel={batteryLevel}
        generalAlerts={generalAlerts}
        isPluggedIn={isPluggedIn}
      />

      <Card.Body style={{ padding: '0.5rem', flexGrow: 1 }}>
        <Card
          className="h-100"
          style={{
            borderRadius: '10px',
            borderColor: '#d3d3d3',
          }}
        >
          <ReadingDisplay
            {...reading1}
            size="large"
          />
        </Card>
      </Card.Body>
    </Card>
  </div>
);

SingleReadingCard.propTypes = {
  sensorName: PropTypes.string.isRequired,
  typeName: PropTypes.string.isRequired,
  macAddress: PropTypes.string,
  lastUpdated: PropTypes.string.isRequired,
  reading1: PropTypes.shape({
    title: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]).isRequired,
    units: PropTypes.string.isRequired,
    isTriggered: PropTypes.bool || null,
    channelKey: PropTypes.string,
  }),
  isHub: PropTypes.bool,
  rssi: PropTypes.number,
  isWireless: PropTypes.bool.isRequired,
  batteryLevel: PropTypes.number,
  onSettingsClick: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  generalAlerts: PropTypes.array,
  isPluggedIn: PropTypes.bool,
  isMuted: PropTypes.bool,
};

export default SingleReadingCard;
